import { Fragment } from 'react';

import { Breadcrumb } from '@components/breadcrumb';
import { PageContainers } from '@components/page-containers';

import { useCompanyInfo } from 'api/companies/hooks';
import { Header } from 'components/headers';
import { Loading } from 'components/Loading';
import { PageContent } from 'components/Page';
import { useStore } from 'models/Provider';

import { CareerLanguage } from './career-languages';
import { CareerSocial } from './career-socials';

export function CareerSettings() {
  const { t } = useStore();

  const { data: companyInfo } = useCompanyInfo();
  if (!companyInfo) return <Loading />;
  return (
    <Fragment>
      <Header
        breadcrumbs={<Breadcrumb items={[{ label: t('company.settings.career.header') }]} />}
        mobileTitle={t('company.settings.career.header')}
      />
      <PageContent>
        <PageContainers.MiddleColumnPage space={6}>
          <CareerLanguage companyInfo={companyInfo} />
          <CareerSocial companyInfo={companyInfo} />
        </PageContainers.MiddleColumnPage>
      </PageContent>
    </Fragment>
  );
}
